<template>
  <div>
    <el-form
      style="width: 500px"
      ref="searchForm"
      :rules="searchRules"
      :model="searchForm"
      label-width="120px"
      size="mini"
      labelPosition="right"
      @submit.native.prevent
    >
      <el-form-item label="工单状态" prop="status">
        <el-select size="small" v-model="searchForm.status">
          <el-option
            v-for="item in workorderStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单类型" prop="type">
        <el-select size="small" v-model="searchForm.type">
          <el-option
            v-for="item in alarmorderType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          v-model="searchForm.startTime"
          size="small"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          v-model="searchForm.endTime"
          size="small"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch('searchForm')"
          >确定</el-button
        >
        <el-button @click="cancleSearch">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    let isNumber = this.$filter.isNumber;
    return {
      labelPosition: "left",
      searchForm: this.$store.state.currentSearchForm,
      searchRules: {
        idcard: [
          { validator: isNumber, trigger: "blur" },
          { max: 18, message: "输入正确的身份证号", trigger: "change" }
        ],
        phone: [
          { validator: isNumber, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    startSearch(formName) {
      //所有参数是否为空    是的话 return false   否的话
      if (this.$baseFunc.paramsValidate(this.searchForm)) {
        this.$message({
          type: "error",
          message: "请选择检索参数"
        });
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            searchShow: false,
            searchData: this.searchForm
          };
          this.$emit("startSearch", obj);
        } else {
          return false;
        }
      });
    },
    cancleSearch() {
      let obj = {
        searchShow: false
      };
      this.$emit("cancleSearch", obj);
    }
  },
  created() { }
};
</script>

